<script>
import RightLayout from '../layouts/rightLayout'
import passengerReservationconfirm from '../../components/passengerReservationConfirm'
import seachAddress from '@/components/seachAddress'
import {DateUtil} from '@/utils/date.js'
import $ from 'jquery'
import GoogleMap from '@/components/googleMap'
import dialog from '@/components/Dialog'
import mapTransitPoint3 from '../../assets/map_icon/map_transit_point3.png'

export default {
  components: {
    RightLayout: RightLayout,
    passengerReservationconfirm,
    seachAddress,
    GoogleMap,
    'v-dialog': dialog
  },
  created () {
    console.log("created")
    // 获取编辑 新增的flag标识
    let flag = JSON.parse(sessionStorage.getItem('shiftReservation')).flag
    // 获取乘客信息 ReservationStatus.vueでSET
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    let tempUserInfo = []
    for (let user of this.userInfo) {
      if (user.roleFlag.substring(0, 1) === '1') {
        tempUserInfo.push(user)
      }
    }
    this.userInfo = tempUserInfo
    this.userInfo.sort((x, y) => {
      return (x.lastNamekana + x.firstNamekana).localeCompare(
        y.lastNamekana + y.firstNamekana
      )
    })
    // 予約編集
    if (flag === 'edit') {
      this.shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      this.areaId = this.shiftDetail.shiftInfo.areaId
      this.shiftReservation = JSON.parse(
        sessionStorage.getItem('shiftReservation')
      )
      this.shiftReservation.shiftFlag = this.shiftDetail.shiftInfo.shiftFlag
      this.shiftPasspoints = this.shiftDetail.shiftPasspoints
      // 地域外交通対応
      this.shiftReservation.title = this.shiftReservation.parentTitle
      this.shiftReservation.passengerCost = this.shiftReservation.parentPassengerCost
      // this.shiftDetail.shiftInfo.shiftCost = this.shiftDetail.shiftInfo.parentShiftCost
      this.shiftCost = this.shiftDetail.shiftInfo.parentShiftCost
      this.shiftReservation.pageShiftId = this.shiftReservation.shiftId
      this.shiftReservation.shiftId = this.shiftReservation.reserveParentShiftId
      this.shiftReservation.reserveId = this.shiftReservation.parentReserveId

      this.shiftReservation.startStationId = this.shiftReservation.groupStartStationId
      this.shiftReservation.startPlaceType = this.shiftReservation.groupStartPlaceType
      this.shiftReservation.startEstimateTime = this.shiftReservation.groupStartEstimateTime
      this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(this.shiftReservation.startEstimateTime)

      this.shiftReservation.arriveStationId = this.shiftReservation.groupArriveStationId
      this.shiftReservation.arrivePlaceType = this.shiftReservation.groupArrivePlaceType
      this.shiftReservation.arriveEstimateTime = this.shiftReservation.groupArriveEstimateTime
      this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(this.shiftReservation.arriveEstimateTime)

      // 必ず料金計算を行うように変更
      // if (this.shiftReservation.reserveType === 2) {
        // this.shiftReservation.passengerCost = this.shiftDetail.shiftInfo.shiftCost * this.shiftReservation.passengerNumber
      // }

      // 编辑选中当前乘客
      // 乗客情報取得
      this.userInfo.forEach(item => {
        if (this.shiftReservation.passengerUid === item.uid) {
          this.homeLat = Number(item.homeLat.substring(0, 10))
          this.homeLng = Number(item.homeLng.substring(0, 10))
          this.delegateCost  = item.passengerCost
        }
      })

      this.updateReservationPassengerCost()

      // 自宅チェック
      if (this.shiftReservation.shiftFlag === 0) {
        // 行き
        if (this.shiftReservation.startPlaceType === 1) {
          this.shiftReservation.startPlaceLat = this.homeLat
          this.shiftReservation.startPlaceLng = this.homeLng
        }else{
          // 行きかつ自宅以外から乗車する場合、降車便は区域内便に固定する
          this.disableArriveShift = true
        }
        this.startEstimateTime = this.shiftReservation.startEstimateTime
        this.startType = this.shiftReservation.startPlaceType
      } else if (this.shiftReservation.shiftFlag === 1) {
        // 帰り
        if (this.shiftReservation.arrivePlaceType === 1) {
          this.shiftReservation.arrivePlaceLat = this.homeLat
          this.shiftReservation.arrivePlaceLng = this.homeLng
        }else{
          this.disableStartShift = true
        }
        this.startEstimateTime = this.shiftReservation.arriveEstimateTime
        this.startType = this.shiftReservation.arrivePlaceType
      }
      this.withNumber = this.shiftReservation.passengerNumber - 1
      this.name = this.shiftReservation.lastNameKana + this.shiftReservation.firstNameKana
      if (this.shiftReservation.status === 1) {
        this.numberFlag = this.shiftReservation.passengerNumber
      }
      if (this.shiftReservation.startPlaceType === 2 || this.shiftReservation.arrivePlaceType === 2) {
        this.startStationIndex = this.getArriveIndex(this.shiftReservation.startStationId)
        this.arriveStationIndex = this.getArriveIndex(this.shiftReservation.arriveStationId)
      } else if (this.shiftReservation.shiftFlag === 0 && this.shiftReservation.startPlaceType !== 2) {
        this.arriveStationIndex = this.getArriveIndex(this.shiftReservation.arriveStationId)
      } else if (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.arrivePlaceType !== 2) {
        this.startStationIndex = this.getArriveIndex(this.shiftReservation.startStationId)
      }
      // 地域外交通対応
      this.shiftReservation.parentShiftId = this.shiftReservation.shiftId
      this.shiftReservation.transportKind = this.shiftDetail.shiftInfo.transportKind
      // ルート最適化バッチ適用後の処理
      this.getEstimateTimeAfterOptimize()

      this.getShiftList()
    } else if (flag === 'add') {
      // 新規予約
      this.shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      this.areaId = this.shiftDetail.shiftInfo.areaId
      this.shiftReservation.shiftFlag = this.shiftDetail.shiftInfo.shiftFlag
      this.shiftPasspoints = this.shiftDetail.shiftPasspoints
      this.shiftReservation.title = this.shiftDetail.shiftInfo.title
      this.shiftReservation.shiftId = this.shiftDetail.shiftInfo.shiftId
      this.shiftReservation.time.useTime = this.shiftDetail.shiftInfo.moveShiftTime
      this.shiftReservation.moveShiftTime = this.shiftDetail.shiftInfo.moveShiftTime
      this.shiftReservation.useTime = this.shiftDetail.shiftInfo.useTime
      this.shiftReservation.reserveType = 1
      this.shiftReservation.startPlaceType = 1
      this.shiftReservation.arrivePlaceType = 1
      // this.shiftDetail.shiftInfo.shiftCost = this.shiftDetail.shiftInfo.parentShiftCost
      this.shiftCost = this.shiftDetail.shiftInfo.parentShiftCost
      // this.shiftReservation.passengerCost = this.shiftDetail.shiftInfo.shiftCost
      this.updateReservationPassengerCost()
      this.shiftReservation.flag = JSON.parse(sessionStorage.getItem('shiftReservation')).flag
      // 人数大于3キャンセル待ち小于確認
      if (this.shiftDetail.shiftInfo.parentRePassengerNumber < this.shiftDetail.shiftInfo.parentPassengerNumber) {
        this.shiftReservation.status = 1
      } else {
        this.shiftReservation.status = 2
      }
      // 地域外交通対応
      this.shiftReservation.parentShiftId = this.shiftDetail.shiftInfo.parentShiftId
      this.shiftReservation.transportKind = this.shiftDetail.shiftInfo.transportKind
      // ルート最適化バッチ適用後の処理
      this.getEstimateTimeAfterOptimize()
      // 获取当前时间
      this.getDate()
      // 便一覧作成
      this.getShiftList()

    }

    
  },
  mounted () {
    // this.addOptions()
    // if (this.shiftReservation.flag === 'edit') {
    //   this.editOptions()
    //   if (this.shiftReservation.shiftFlag === 0) {
    //     this.oldLat = this.shiftReservation.startPlaceLat
    //     this.oldLng = this.shiftReservation.startPlaceLng
    //   } else {
    //     this.oldLat = this.shiftReservation.arrivePlaceLat
    //     this.oldLng = this.shiftReservation.arrivePlaceLng
    //   }
    // }
    // this.$axios.post('shift/getPickUpWaitTime')
    //   .then(response => {
    //     this.shiftReservation.pickUpWaitTime = parseInt(response.data.pickUpWaitTime)
    //   })
    // // 当前界面弹出框出现禁掉shift和tap键
    // $(document).keydown(function (event) {
    //   if ($('#passengerFlag').length > 0) {
    //     switch (event.keyCode) {
    //       case 9:case 16:
    //         if ($('body').hasClass('modal-open') === true || (this.showDialog === true && !Object.is(this.showDialog, undefined))) {
    //           return false
    //         } else {
    //           return true
    //         }
    //     }
    //   }
    // })
  },
  watch: {
    // mountedから移動
    isLoading: function(newval){
      if(newval === false){
        this.addOptions()
        if (this.shiftReservation.flag === 'edit') {
          this.editOptions()
          if (this.shiftReservation.shiftFlag === 0) {
            this.oldLat = this.shiftReservation.startPlaceLat
            this.oldLng = this.shiftReservation.startPlaceLng
          } else {
            this.oldLat = this.shiftReservation.arrivePlaceLat
            this.oldLng = this.shiftReservation.arrivePlaceLng
          }
        }
        this.$axios.post('shift/getPickUpWaitTime')
          .then(response => {
            this.shiftReservation.pickUpWaitTime = parseInt(response.data.pickUpWaitTime)
          })
        // 当前界面弹出框出现禁掉shift和tap键
        $(document).keydown(function (event) {
          if ($('#passengerFlag').length > 0) {
            switch (event.keyCode) {
              case 9:case 16:
                if ($('body').hasClass('modal-open') === true || (this.showDialog === true && !Object.is(this.showDialog, undefined))) {
                  return false
                } else {
                  return true
                }
            }
          }
        })
      }
    },
    homeLat: function () {
      if (this.shiftReservation.flag === 'add') {
        if (this.shiftReservation.shiftFlag === 0 && this.shiftReservation.startPlaceType === 1) {
          this.shiftReservation.startPlaceLat = this.homeLat
          this.shiftReservation.startPlaceLng = this.homeLng
          this.newPlan()
        } else if (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.arrivePlaceType === 1) {
          this.shiftReservation.arrivePlaceLat = this.homeLat
          this.shiftReservation.arrivePlaceLng = this.homeLng
          this.newPlan()
        }
        // this.plan()
      }
    },
    // 同乘者人数监控
    // 同乗者人数変更時イベント
    withNumber (news) {
      if (news !== null && news !== '' && news !== undefined) {
        if (!isNaN(news)) {
          this.withNumber = Number(news)
          
          // 料金計算処理
          this.shiftReservation.passengerNumber = 1
          this.shiftReservation.passengerNumber += this.withNumber
          // this.shiftReservation.passengerCost = this.shiftReservation.passengerNumber * this.shiftDetail.shiftInfo.shiftCost
          this.updateReservationPassengerCost()

          // 予約可能人数確認処理
          let number
          if (this.shiftReservation.flag === 'add') {
            // 新增 同乘者预约人数加已经预约人数
            number = this.shiftDetail.shiftInfo.parentRePassengerNumber + this.shiftReservation.passengerNumber
          } else {
            // 修改时候一进来是确定的时候  预约人数加(已经预约的人数减去之前此人预约的人数)
            number = this.shiftReservation.passengerNumber + (this.shiftDetail.shiftInfo.parentRePassengerNumber - this.numberFlag)
          }
          // 同乘人数不能大于车辆的定员数
          if (this.shiftReservation.passengerNumber > this.shiftDetail.shiftInfo.parentPassengerNumber) {
            this.dialogOption.showNo = false
            this.dialogOption.text = '乗車人数の上限を超えています'
            this.dialogOption.confirmButtonText = '確定'
            this.showDialog = true
            this.$refs.dialog.confirm().then(() => {
              this.withNumber = 0
              this.showDialog = false
            })
            // 同乘人数加预约人数加预约的人数大于总共的可预约的人数弹出框
          } else if (number > this.shiftDetail.shiftInfo.parentPassengerNumber) {
            if (this.shiftReservation.status !== 2) {
              this.dialogOption.showNo = true
              this.dialogOption.text = 'この予約はキャンセル待ちとなります<br/>予約を続けますか?'
              this.dialogOption.confirmButtonText = 'はい'
              this.showDialog = true
              // 状态修改为等待
              this.$refs.dialog.confirm().then(() => {
                this.shiftReservation.status = 2
                this.showDialog = false
              }).catch(() => {
                this.showDialog = false
                // 清空
                this.withNumber = 0
              })
            }
          } else {
            this.shiftReservation.status = 1
          }
        }
      }
    }
  },
  methods: {
    // 添加停留所
    // 行きの場合乗車場所に、帰りの場合は降車場所に適用される
    addOptions () {
      console.log("addOptions")
      let i = 0
      let model = document.getElementById('startPlaceSelect')
      console.log(this.shiftPasspoints)
      this.shiftPasspoints.forEach(element => {
        if (element.routeType === '0' && element.officeFlag === 0) {
          // 起点不包含
          // if (i === 0) {
            // i++
          // } else {
            if(element.shiftId == this.shiftReservation.parentShiftId){
              let index = model.options.length + 1
              this.options.push({address: element.stationName,
                stationLat: element.stationLat,
                stationLng: element.stationLng,
                startStationId: element.stationId,
                officeFlag: element.officeFlag})
              if(this.shiftReservation.shiftFlag === 0){
                model.options[model.options.length] = new Option(element.stationName, index)
              }else{
                model.options[model.options.length] = new Option(element.stationName, index - 1)
              }
            }
          // }
        }
      })
      // 终点不包含不包含
      if(this.shiftReservation.shiftFlag === 0){
        // 行きの時は最後での乗車を除外する
        this.options.pop()
        model.remove(model.options.length - 1)
      }else{
        console.log(this.options)
        console.log(model)
        // 帰りの時は最初（自宅の次）での降車を除外する
        // 先頭を除外だと自宅を除外してしまう
        // this.options.splice(1,1)
        this.options.shift()
        model.remove(1)
      }
      this.shiftReservation.size = model.options.length
    },
    editOptions () {
      // 获取select元素
      let model = document.getElementById('startPlaceSelect')
      let index = model.options.length + 1
      let endtype = this.shiftReservation.arrivePlaceType
      let startType = this.shiftReservation.startPlaceType
      let i = 0
      // 获取停留所并选中
      this.shiftPasspoints.forEach(item => {
        if (item.routeType === '0') {
          i++
          if (this.shiftReservation.shiftFlag === 0) {
            if (this.shiftReservation.arriveStationId === item.stationId) {
              this.tation = item
              this.shiftReservation.name = item.stationName
            }
            if (this.shiftReservation.startStationId === item.stationId) {
              this.shiftReservation.startPlaceType = i
              this.shiftReservation.startPlaceName = item.stationName
              this.shiftReservation.startPlaceLat = item.stationLat
              this.shiftReservation.startPlaceLng = item.stationLng
            }
          } else {
            if (this.shiftReservation.startStationId === item.stationId) {
              this.tation = item
              this.shiftReservation.name = item.stationName
            }
            if (this.shiftReservation.arriveStationId === item.stationId) {
              this.shiftReservation.arrivePlaceType = i
              this.shiftReservation.arrivePlaceName = item.stationName
              this.shiftReservation.arrivePlaceLat = item.stationLat
              this.shiftReservation.arrivePlaceLng = item.stationLng
            }
          }
        }
      })
      // 获取地图选的地址
      if (startType === 3) {
      // 添加一个Option 行
        this.options.push({address: this.shiftReservation.startPlaceName,
          stationLat: this.shiftReservation.startPlaceLat,
          stationLng: this.shiftReservation.startPlaceLng})
        model.options[model.options.length] = new Option(this.shiftReservation.startPlaceName, index)
        // 设为选中
        this.shiftReservation.startPlaceType = index
      }
      if (endtype === 3) {
      // 添加一个Option 归
        this.options.push({address: this.shiftReservation.arrivePlaceName,
          stationLat: this.shiftReservation.arrivePlaceLat,
          stationLng: this.shiftReservation.arrivePlaceLng})
        model.options[model.options.length] = new Option(this.shiftReservation.arrivePlaceName, index)
        this.shiftReservation.arrivePlaceType = index
      }
    },
    // 登录
    submit () {
      let checkLng = 0
      let checkLat = 0
      let placeType = 1
      if (this.shiftReservation.shiftFlag === 0) {
        checkLng = this.shiftReservation.startPlaceLng
        checkLat = this.shiftReservation.startPlaceLat
        if (this.shiftReservation.startPlaceType < this.shiftReservation.size + 1) {
          if (Number(this.shiftReservation.startPlaceType) !== 1) {
            placeType = 2
          }
        } else {
          placeType = 3
        }
      } else {
        checkLng = this.shiftReservation.arrivePlaceLng
        checkLat = this.shiftReservation.arrivePlaceLat
        if (this.shiftReservation.arrivePlaceType < this.shiftReservation.size + 1) {
          if (Number(this.shiftReservation.arrivePlaceType) !== 1) {
            placeType = 2
          }
        } else {
          placeType = 3
        }
      }
      // 传值给共享仓库
      console.log("コミット直前")
      console.log(this.shiftReservation)
      this.$store.commit('SET_SHITINFO', this.shiftReservation)

      let exsitInAreaScopeFlag = false

      // 验证
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.areaId === null || this.areaId === '' || this.reserveStatus !== '4') {
            $('#modal-container-475051').modal('show')
          } else {
            if ((this.shiftReservation.shiftFlag === 0 && (placeType === 1 || placeType === 3)) || (this.shiftReservation.shiftFlag === 1 && (placeType === 1 || placeType === 3))) {
              this.$axios.get('shift/exsitInAreaScopeByAreaId', {params: {areaId: this.areaId, lng: checkLng, lat: checkLat}})
                .then(response => {
                  exsitInAreaScopeFlag = response.data.exsitInAreaScopeFlag
                  if (exsitInAreaScopeFlag) {
                    $('#modal-container-475051').modal('show')
                  } else {
                    this.dialogOption.showNo = false
                    this.dialogOption.text = 'そのエリアからは予約できません。場所を変更してくだい。'
                    this.dialogOption.confirmButtonText = '確定'
                    this.showDialog = true
                    this.$refs.dialog.confirm().then(() => {
                      this.showDialog = false
                    })
                    $('.modal-backdrop').remove()
                  }
                })
            } else {
              $('#modal-container-475051').modal('show')
            }
          }
        } else {
          $('#modal-container-475051').modal('hide')
        }
      })
    },
    canCancelWaitReserve () {
      let reserveStatus = 1
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$axios.post('shift/canCancelWaitReservation', this.shiftReservation).then(response => {
            reserveStatus = response.data.reserveStatus
            if (reserveStatus === '4') {
              this.dialogOption.showNo = false
              this.dialogOption.text = '乗車人数の上限を超えています'
              this.dialogOption.confirmButtonText = '確定'
              this.showDialog = true
              this.$refs.dialog.confirm().then(() => {
                this.withNumber = 0
                this.showDialog = false
              })
              // 同乘人数加预约人数加预约的人数大于总共的可预约的人数弹出框
            } else if (reserveStatus === '2') {
              this.dialogOption.showNo = true
              this.dialogOption.text = 'この予約はキャンセル待ちとなります<br/>予約を続けますか?'
              this.dialogOption.confirmButtonText = 'はい'
              this.showDialog = true
              // 状态修改为等待
              this.$refs.dialog.confirm().then(() => {
                this.shiftReservation.status = 2
                this.showDialog = false
                this.submit()
              }).catch(() => {
                this.showDialog = false
                // 清空
                this.withNumber = 0
              })
            } else {
              this.shiftReservation.status = 1
              this.submit()
            }
          })
        }
      })
    },
    // 返回
    goback () {
      this.$router.go(-1)
    },
    // 乗客選択時イベント
    selectPassengerEvent (val) {
      var params = new URLSearchParams()
      params.append('shiftId', this.shiftReservation.shiftId)
      params.append('uid', val.uid)
      this.$axios.post('shift/existUserInShift', params)
        .then(response => {
          if (response.data.existUserInShift) {
            this.dialogOption.showNo = false
            this.dialogOption.text = '既に予約されているため、複数予約はできません。'
            this.dialogOption.confirmButtonText = '確定'
            this.showDialog = true
            this.$refs.dialog.confirm().then(() => {
              this.showDialog = false
              this.event = null
              this.name = ''
            })
          } else {
            this.shiftReservation.passengerUid = val.uid
            this.shiftReservation.firstNameKana = val.firstNamekana
            this.shiftReservation.lastNameKana = val.lastNamekana
            this.shiftReservation.firstName = val.firstName
            this.shiftReservation.lastName = val.lastName
            this.homeLat = Number(val.homeLat.substring(0, 10))
            this.homeLng = Number(val.homeLng.substring(0, 11))
            this.name = val.lastNamekana + val.firstNamekana
            this.delegateCost = val.passengerCost
            this.updateReservationPassengerCost()
          }
        })
    },
    reserveType (val) {
      this.shiftReservation.reserveType = val
    },
    // 乘车场所
    // 【行き】乗車場所選択時処理
    // 【帰り】降車場所選択時処理
    startPlaceType (val) {
      console.log("startPlaceType")
      let index = Number(val)
      if (this.shiftReservation.shiftFlag === 0) {
        this.shiftReservation.startPlaceType = index
        // 自宅上车
        if (index - 2 < 0) {
          this.shiftReservation.startPlaceLat = this.homeLat
          this.shiftReservation.startPlaceLng = this.homeLng
          // this.plan()
          this.disableArriveShift = false
          this.newPlan()
          return
        }else{
          // 行きかつ自宅以外から乗車する場合、降車便は区域内便に固定する
          if(this.shiftReservation.arriveShiftId != this.shiftReservation.parentShiftId){
            this.shiftReservation.arriveShiftId = this.shiftReservation.parentShiftId
            this.tation = null
          }
          this.disableArriveShift = true
        }
        // 停留所上车
        if (index < this.options.length + 2 && index > 1) {
          this.shiftReservation.startStationId = this.options[index - 2].startStationId
          this.shiftReservation.startPlaceName = this.options[index - 2].address
          this.shiftReservation.startPlaceLat = Number(this.options[index - 2].stationLat)
          this.shiftReservation.startPlaceLng = Number(this.options[index - 2].stationLng)
          if (this.shiftReservation.arriveStationId !== '') {
            // this.checkEstimateTime()でチェックするように変更
            // let start = this.getArriveIndex(this.shiftReservation.startStationId)
            // let arrive = this.getArriveIndex(this.shiftReservation.arriveStationId)
            // if (arrive <= start) {
            //   console.log("err1")
            //   this.dialogOption.showNo = false
            //   this.dialogOption.text = '乗車場所と降車場所の順序が正しくありません。'
            //   this.dialogOption.confirmButtonText = '確定'
            //   this.showDialog = true
            //   this.$refs.dialog.confirm().then(() => {
            //     this.showDialog = false
            //     this.shiftReservation.startStationId = ''
            //     this.shiftReservation.startPlaceType = null
            //   })
            // } else {
              this.newPlan()
            // }
          }
        } else {
          // 地图选址上车
          this.shiftReservation.startPlaceName = this.options[index - 2].address
          this.shiftReservation.startPlaceLat = Number(this.options[index - 2].stationLat)
          this.shiftReservation.startPlaceLng = Number(this.options[index - 2].stationLng)
          this.newPlan()
        }
      } else {
        // 自宅下车
        if (index - 2 < 0) {
          this.shiftReservation.arrivePlaceLat = this.homeLat
          this.shiftReservation.arrivePlaceLng = this.homeLng
          // this.plan()
          this.disableStartShift = false
          this.newPlan()
          return
        }else{
          // 帰りかつ自宅以外から降車する場合、降車便は区域内便に固定する
          if(this.shiftReservation.startShiftId != this.shiftReservation.parentShiftId){
            this.shiftReservation.startShiftId = this.shiftReservation.parentShiftId
            this.tation = null
          }
          this.disableStartShift = true
        }
        this.shiftReservation.arrivePlaceType = index
        // 停留所下车
        if (index < this.options.length + 2 && index > 1) {
          this.shiftReservation.arriveStationId = this.options[index - 2].startStationId
          this.shiftReservation.arrivePlaceName = this.options[index - 2].address
          this.shiftReservation.arrivePlaceLat = Number(this.options[index - 2].stationLat)
          this.shiftReservation.arrivePlaceLng = Number(this.options[index - 2].stationLng)
          if (!Object.is(this.shiftReservation.startStationId, undefined) && this.shiftReservation.startStationId !== '') {
            // this.checkEstimateTime()でチェックするように変更
            // let start = this.getArriveIndex(this.shiftReservation.startStationId)
            // let arrive = this.getArriveIndex(this.shiftReservation.arriveStationId)
            // if (arrive <= start) {
            //   console.log("err2")
            //   console.log("arrive")
            //   console.log(arrive)
            //   console.log("start")
            //   console.log(start)
            //   this.dialogOption.showNo = false
            //   this.dialogOption.text = '乗車場所と降車場所の順序が正しくありません。'
            //   this.dialogOption.confirmButtonText = '確定'
            //   this.showDialog = true
            //   this.$refs.dialog.confirm().then(() => {
            //     this.showDialog = false
            //     this.shiftReservation.arriveStationId = ''
            //     this.shiftReservation.arrivePlaceType = null
            //   })
            // } else {
              this.newPlan()
            // }
          }
        } else {
          // 地图选址下车
          this.shiftReservation.arrivePlaceName = this.options[index - 2].address
          this.shiftReservation.arrivePlaceLat = Number(this.options[index - 2].stationLat)
          this.shiftReservation.arrivePlaceLng = Number(this.options[index - 2].stationLng)
          this.newPlan()
        }
      }
      // this.plan()
    },
    // 降车场所
    station (tation) {
      console.log("station()")
      if(tation == null){
        return
      }
      if (this.shiftReservation.shiftFlag === 0) {
        this.shiftReservation.arrivePlaceType = 2
        this.shiftReservation.arriveStationId = tation.stationId
        this.shiftReservation.name = tation.stationName
        // this.shiftReservation.name = tation.name
      } else {
        this.shiftReservation.startPlaceType = 2
        this.shiftReservation.startStationId = tation.stationId
        this.shiftReservation.name = tation.stationName
        // this.shiftReservation.name = tation.name
      }
      if ((this.shiftReservation.shiftFlag === 0 && this.shiftReservation.startStationId !== '' && Number(this.shiftReservation.startPlaceType) !== 1) ||
      (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.startStationId !== '' && Number(this.shiftReservation.arrivePlaceType) !== 1)) {
        let start = this.getArriveIndex(this.shiftReservation.startStationId)
        let arrive = this.getArriveIndex(this.shiftReservation.arriveStationId)

        // this.checkEstimateTime()でチェックするように変更
        // if (arrive <= start) {
        // // if (arriveTime < startTime) {
        //   console.log("err3")
        //   console.log("arrive")
        //   console.log(arrive)
        //   // console.log(this.shiftReservation.arriveEstimateTime)
        //   console.log("start")
        //   console.log(start)
        //   // console.log(this.shiftReservation.startEstimateTime)
        //   this.dialogOption.showNo = false
        //   this.dialogOption.text = '乗車場所と降車場所の順序が正しくありません。'
        //   this.dialogOption.confirmButtonText = '確定'
        //   this.showDialog = true
        //   this.$refs.dialog.confirm().then(() => {
        //     this.showDialog = false
        //     this.tation = null
        //     if (this.shiftReservation.shiftFlag === 0) {
        //       this.shiftReservation.arriveStationId = ''
        //     } else {
        //       this.shiftReservation.startStationId = ''
        //     }
        //   })
        // } else {
          this.newPlan()
        // }
      } else {
        this.newPlan()
      }
      // this.plan()
    },
    // 地图选址
    getHomeAddress (selectValue) {
      let selectValues = Object.assign({}, selectValue)
      // 获取select元素
      let model = document.getElementById('startPlaceSelect')
      // 添加一个Option
      this.options.push(selectValues)
      let index = Number(model.options[model.options.length - 1].value) + 1
      model.options[model.options.length] = new Option(selectValues.address, index)
      // 判断行归
      if (this.shiftReservation.shiftFlag === 0) {
        this.shiftReservation.startPlaceType = index
        this.shiftReservation.startPlaceLat = Number(selectValue.stationLat)
        this.shiftReservation.startPlaceLng = Number(selectValue.stationLng)
        this.shiftReservation.startPlaceName = selectValue.address
      } else {
        this.shiftReservation.arrivePlaceType = index
        this.shiftReservation.arrivePlaceLat = Number(selectValue.stationLat)
        this.shiftReservation.arrivePlaceLng = Number(selectValue.stationLng)
        this.shiftReservation.arrivePlaceName = selectValue.address
      }
      model[model.length - 1].selected = true
      // this.plan()
      this.newPlan()
    },
    // 获取当前日期
    getDate () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
      let day = date.getDate() >= 10 ? date.getDate() : '0' + (date.getDate())
      let hour = date.getHours() >= 10 ? date.getHours() : '0' + (date.getHours())
      let minute = date.getMinutes()
      let seconds = date.getSeconds()
      if (minute < 10) {
        minute = '0' + minute
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      this.shiftReservation.reserveTime = year + '' + month + day + hour + minute + seconds
      this.shiftReservation.time.reserveTime =
        year + '年 ' + month + '月 ' + day + '日 ' + hour + ':' + minute
    },
    // 计算上下车停留所所在下标 返回经纬度
    getStartIndex () {
      let start = []
      let shiftPasspoints = this.shiftPasspoints
      for (let index = 0; index < shiftPasspoints.length; index++) {
        const element = shiftPasspoints[index]
        if (this.shiftReservation.shiftFlag === 0) {
          if (this.shiftReservation.arriveStationId === element.stationId) {
            start.push(index, this.shiftReservation.startPlaceLat, this.shiftReservation.startPlaceLng)
            return start
          }
        } else {
          if (this.shiftReservation.startStationId === element.stationId) {
            start.push(index, this.shiftReservation.arrivePlaceLat, this.shiftReservation.arrivePlaceLng)
            return start
          }
        }
      }
    },
    getArriveIndex (stationId) {
      for (let index = 0; index < this.shiftPasspoints.length; index++) {
        const element = this.shiftPasspoints[index]
        if (stationId === element.stationId) {
          return index
        }
      }
    },
    initAddressChoice () {
      let lat
      let lng
      let name
      if ((this.shiftReservation.shiftFlag === 0 && Number(this.shiftReservation.startPlaceType) === 1 && this.homeLat !== '') || (this.shiftReservation.shiftFlag === 1 && Number(this.shiftReservation.arrivePlaceType) === 1 && this.homeLat !== '')) {
        lat = this.homeLat
        lng = this.homeLng
        name = '自宅'
      } else if (this.shiftReservation.shiftFlag === 0 && !Object.is(this.shiftReservation.startPlaceLng, undefined)) {
        lat = this.shiftReservation.startPlaceLat
        lng = this.shiftReservation.startPlaceLng
        name = this.shiftReservation.startPlaceName
      } else if (this.shiftReservation.shiftFlag === 1 && !Object.is(this.shiftReservation.arrivePlaceLat, undefined)) {
        lat = this.shiftReservation.arrivePlaceLat
        lng = this.shiftReservation.arrivePlaceLng
        name = this.shiftReservation.arrivePlaceName
      }
      // 设置图标大小
      let imgSize = {width: 52, height: 76}
      // 设置图标样式
      let personPoint = {
        name: name,
        lat: lat,
        lng: lng,
        icon: mapTransitPoint3
      }
      if (this.shiftReservation.shiftFlag === 0) {
        this.$refs.homeAddressChoice.title = '乗車場所を選択'
      } else {
        this.$refs.homeAddressChoice.title = '降車場所を選択'
      }
      this.$refs.homeAddressChoice.centerPoint = this.centerPoint
      this.$refs.homeAddressChoice.initAddressChoice(personPoint, imgSize)

      // マップで探す場合、乗車（降車）場所を区域内に固定する
      if (this.shiftReservation.shiftFlag === 0){
        this.shiftReservation.arriveShiftId = this.shiftReservation.parentShiftId
        this.tation = null
        this.disableArriveShift = true
      }else{
        this.shiftReservation.startShiftId = this.shiftReservation.parentShiftId
        this.tation = null
        this.disableStartShift = true
      }
    },
    stationIsDown (stationId) {
      for (let element of this.shiftDetail.shiftInfo.shiftReservationInfos) {
        if (this.shiftReservation.flag === 'edit' && element.reserveId === this.shiftReservation.reserveId) {
          continue
        }
        if (element.startStationId === stationId || stationId === element.arriveStationId) {
          return true
        }
      }
      return false
    },
    newPlan () {
      console.log("newPlanCheck")
      // 判断如果没选停留所或者人的时候不计算
      if ((this.shiftReservation.shiftFlag === 0 && this.shiftReservation.arrivePlaceType === 1) || (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.startPlaceType === 1)) {
        return
      }
      if ((this.shiftReservation.shiftFlag === 0 && Number(this.shiftReservation.startPlaceType) !== 1 && this.shiftReservation.arriveStationId === '') 
      || (this.shiftReservation.shiftFlag === 0 && Number(this.shiftReservation.startPlaceType) !== 1 && Number(this.shiftReservation.startPlaceType) < this.shiftReservation.size + 1 && this.shiftReservation.startStationId === '')) {
        return
      }
      if ((this.shiftReservation.shiftFlag === 1 && Number(this.shiftReservation.arrivePlaceType) !== 1 && Number(this.shiftReservation.arrivePlaceType) < this.shiftReservation.size + 1 && this.shiftReservation.arriveStationId === '') 
      || (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.startStationId === '')) {
        return
      }
      if (this.tation == null){
        return
      }
      let lat
      let lng
      let stationIndex = -1
      // 行在停留所上车 上车时间为所选上车停留所的降车时间  下车时间为所选下车停留所的降车时间
      if (this.shiftReservation.shiftFlag === 0 && Number(this.shiftReservation.startPlaceType) < this.shiftReservation.size + 1 && Number(this.shiftReservation.startPlaceType) !== 1) {
        stationIndex = this.getArriveIndex(this.shiftReservation.startStationId)
        let startEstimateTime = this.shiftPasspoints[stationIndex].estimateTime
        if (this.shiftReservation.flag !== 'edit') {
          if (!this.stationIsDown(this.shiftPasspoints[stationIndex].stationId) && this.shiftReservation.pickUpWaitTime > 0) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime)
          }
        } else {
          if (stationIndex < this.startStationIndex && !this.stationIsDown(this.shiftPasspoints[stationIndex].stationId) && this.shiftReservation.pickUpWaitTime > 0) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime)
          }
          if (this.shiftPasspoints[this.arriveStationIndex - 1].routeType === '1' && !this.stationIsDown(this.shiftPasspoints[this.arriveStationIndex].stationId)) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime * -1)
          }
        }
        this.shiftReservation.startEstimateTime = startEstimateTime
        this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(startEstimateTime)
        let arriveEstimateTime = this.tation.estimateTime
        if (this.shiftReservation.pickUpWaitTime > 0) {
          if (this.shiftReservation.flag !== 'edit') {
            if (!this.stationIsDown(this.tation.stationId) && !this.stationIsDown(this.shiftPasspoints[stationIndex].stationId) && this.shiftPasspoints[stationIndex].stationId !== this.tation.stationId) {
              arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime * 2)
            } else if (!this.stationIsDown(this.tation.stationId) || !this.stationIsDown(this.shiftPasspoints[stationIndex].stationId)) {
              arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
            }
          } else {
            let arationIndex = this.getArriveIndex(this.shiftReservation.arriveStationId)
            if (this.shiftPasspoints[this.arriveStationIndex - 1].routeType === '1' && !this.stationIsDown(this.shiftPasspoints[this.arriveStationIndex].stationId)) {
              arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime * -1)
            }
            if (arationIndex !== this.arriveStationIndex && !this.stationIsDown(this.tation.stationId) && stationIndex !== this.startStationIndex && !this.stationIsDown(this.shiftPasspoints[this.getArriveIndex(this.shiftReservation.startStationId)].stationId) && this.tation.stationId !== this.shiftReservation.startStationId) {
              arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
            } else if ((stationIndex === this.startStationIndex && !this.stationIsDown(this.shiftReservation.arriveStationId))) {
              arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
            }
          }
        }
        this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(arriveEstimateTime)
        this.shiftReservation.arriveEstimateTime = arriveEstimateTime
        this.checkEstimateTime()
        return
      // 归在停留所下车 上车时间为所选上车停留所的降车时间  下车时间为所选下车停留所的降车时间
      } else if (this.shiftReservation.shiftFlag === 1 && Number(this.shiftReservation.arrivePlaceType) < this.shiftReservation.size + 1 && Number(this.shiftReservation.arrivePlaceType) !== 1) {
        stationIndex = this.getArriveIndex(this.shiftReservation.startStationId)
        let arriveStationIndex = this.getArriveIndex(this.shiftReservation.arriveStationId)
        let startEstimateTime = this.tation.estimateTime
        if (this.shiftReservation.flag !== 'edit') {
          if (!this.stationIsDown(this.tation.stationId) && this.shiftReservation.pickUpWaitTime > 0) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime)
          }
        } else {
          if (stationIndex < this.startStationIndex && !this.stationIsDown(this.tation.stationId) && this.shiftReservation.pickUpWaitTime > 0) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime)
          } else if (arriveStationIndex > this.arriveStationIndex && stationIndex > this.startStationIndex) {
            startEstimateTime = DateUtil.planDateAdd(startEstimateTime, this.shiftReservation.pickUpWaitTime * -1)
          }
        }
        this.shiftReservation.startEstimateTime = startEstimateTime
        this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(startEstimateTime)
        let arriveEstimateTime = this.shiftPasspoints[arriveStationIndex].estimateTime
        if (this.shiftReservation.flag !== 'edit') {
          if (!this.stationIsDown(this.shiftReservation.startStationId) && !this.stationIsDown(this.shiftReservation.arriveStationId) && this.shiftReservation.arriveStationId !== this.shiftReservation.startStationId) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime * 2)
          } else if (!this.stationIsDown(this.shiftReservation.startStationId) || !this.stationIsDown(this.shiftReservation.arriveStationId)) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
          }
        } else {
          if (arriveStationIndex < this.arriveStationIndex && stationIndex < this.startStationIndex && !this.stationIsDown(this.tation.stationId) && !this.stationIsDown(this.shiftReservation.arriveStationId)) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime * 2)
          } else if (arriveStationIndex < this.arriveStationIndex && stationIndex === this.startStationIndex) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
          } else if (arriveStationIndex < this.arriveStationIndex && stationIndex > this.startStationIndex && !this.stationIsDown(this.shiftPasspoints[stationIndex].stationId)) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
          } else if (stationIndex < this.startStationIndex && !this.stationIsDown(this.shiftReservation.startStationId)) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
          } else if (Object.is(this.arriveStationIndex, undefined) && arriveStationIndex > 0 && stationIndex === this.startStationIndex && !this.stationIsDown(this.shiftReservation.arriveStationId)) {
            arriveEstimateTime = DateUtil.planDateAdd(arriveEstimateTime, this.shiftReservation.pickUpWaitTime)
          }
        }
        this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(arriveEstimateTime)
        this.shiftReservation.arriveEstimateTime = arriveEstimateTime

        this.checkEstimateTime()
        return
      }
      // 如果为地图选址或自宅 取经纬度
      if (this.shiftReservation.shiftFlag === 0) {
        lat = this.shiftReservation.startPlaceLat
        lng = this.shiftReservation.startPlaceLng
      } else {
        lat = this.shiftReservation.arrivePlaceLat
        lng = this.shiftReservation.arrivePlaceLng
      }
      if(lat == null || lng == null){
        return
      }
      var params = new URLSearchParams()
      // 区域内の便IDを投げる このIDを元に自宅への到着時間を取得している？
      params.append('shiftId', this.shiftReservation.parentShiftId)
      //   params.append('shiftId', this.shiftReservation.shiftId)
      params.append('lat', lat)
      params.append('lng', lng)
      params.append('stationId', this.shiftReservation.startStationId)
      params.append('reserveId', this.shiftReservation.reserveId)

      // 把点放入后台计算乘车时间 降车时间
      this.$axios.post('shift/getEstimateTime', params)
        .then(response => {
          console.log("getEstimateTime")
          let startEstimateTime = response.data.startEstimateTime
          if (this.shiftReservation.shiftFlag === 0) {
            let estimateTime = this.tation.estimateTime
            // 判断下车停留所是否有人已经上车 没有的话加等待时间
            if (this.shiftReservation.pickUpWaitTime > 0) {
              if (this.shiftReservation.flag !== 'edit') {
                if (!this.stationIsDown(this.tation.stationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime * 2)
                } else {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime)
                }
              } else {
                stationIndex = this.getArriveIndex(this.shiftReservation.arriveStationId)
                if (stationIndex > this.arriveStationIndex && !this.stationIsDown(this.shiftPasspoints[this.arriveStationIndex].stationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime * -1)
                }
                if (!this.stationIsDown(this.shiftReservation.arriveStationId)) {
                  if (stationIndex !== this.arriveStationIndex) {
                    estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime)
                  }
                }
              }
            }
            if (lat === this.shiftReservation.startPlaceLat && lng === this.shiftReservation.startPlaceLng) {
              this.shiftReservation.startEstimateTime = startEstimateTime
              this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(startEstimateTime)
              this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(estimateTime)
              this.shiftReservation.arriveEstimateTime = estimateTime
            }
          } else {
            let estimateTime = this.tation.estimateTime
            if (this.shiftReservation.pickUpWaitTime > 0) {
              if (this.shiftReservation.flag !== 'edit') {
                if (!this.stationIsDown(this.tation.stationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime)
                }
              } else {
                stationIndex = this.getArriveIndex(this.shiftReservation.startStationId)
                if (stationIndex < this.startStationIndex && !this.stationIsDown(this.shiftReservation.startStationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime)
                } else if (stationIndex > this.startStationIndex && this.stationIsDown(this.shiftPasspoints[this.startStationIndex].stationId) && !this.stationIsDown(this.shiftReservation.startStationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime)
                } else if (stationIndex > this.startStationIndex && !this.stationIsDown(this.shiftPasspoints[this.startStationIndex].stationId)) {
                  estimateTime = DateUtil.planDateAdd(estimateTime, this.shiftReservation.pickUpWaitTime * -1)
                }
              }
            }
            if (lat === this.shiftReservation.arrivePlaceLat && lng === this.shiftReservation.arrivePlaceLng) {
              this.shiftReservation.startEstimateTime = estimateTime
              this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(estimateTime)
              this.shiftReservation.arriveEstimateTime = startEstimateTime
              this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(startEstimateTime)
            }
          }
          this.checkEstimateTime()
        }).catch(err => {
          console.log(err)
          this.shiftReservation.startPlaceType = null
          this.shiftReservation.time.startEstimateTime = null
          this.shiftReservation.arrivePlaceType = null
          this.shiftReservation.time.arriveEstimateTime = null
          this.tation = null
          this.dialogOption.showNo = false
          this.dialogOption.text = '予定時間の計算に失敗しました。正しい場所を選択してください。'
          this.dialogOption.confirmButtonText = '確定'
          this.showDialog = true
          this.$refs.dialog.confirm().then(() => {
            this.showDialog = false
          })
        })
    },
    // 计算乘车时间
    plan () {
      if ((this.shiftReservation.shiftFlag === 0 && this.shiftReservation.arrivePlaceType === 1) || (this.shiftReservation.shiftFlag === 1 && this.shiftReservation.startPlaceType === 1)) {
        return
      }
      let start = this.getStartIndex()
      // 获取乘车下标
      let startIndex = start[0] - 1
      var params = new URLSearchParams()
      let stationId = 'null'
      let tIndex = null
      if (this.shiftReservation.shiftFlag === 0 && Number(this.shiftReservation.startPlaceType) < this.shiftReservation.size + 1 && Number(this.shiftReservation.startPlaceType) !== 1) {
        tIndex = this.getArriveIndex()
        stationId = this.shiftReservation.startStationId
      } else if (this.shiftReservation.shiftFlag === 1 && Number(this.shiftReservation.arrivePlaceType) < this.shiftReservation.size + 1 && Number(this.shiftReservation.arrivePlaceType) !== 1) {
        tIndex = this.getArriveIndex()
        stationId = this.shiftReservation.arriveStationId
      }
      params.append('shiftId', this.shiftReservation.shiftId)
      params.append('lat', start[1])
      params.append('lng', start[2])
      params.append('stationId', stationId)
      params.append('reserveId', this.shiftReservation.reserveId)
      this.$axios.post('shift/getRouteDataFromApi', params)
        .then(response => {
          let legs = response.data.route[0].legs
          let order = response.data.route[0].waypointOrder
          let endIndex
          let start = startIndex
          for (let index = 0; index < order.length; index++) {
            const element = order[index]
            //  获取起点其返回的实际下标
            if (element === start && start !== order.length - 1 && this.shiftReservation.shiftFlag === 0) {
              startIndex = index
            } else if (element === start && start !== order.length - 1 && this.shiftReservation.shiftFlag === 1) {
              startIndex = index + 1
            // 在终点上车
            } else if (start === order.length - 1) {
              startIndex = order.length
            // 在起点上车
            } else if (start === -1) {
              startIndex = 0
            }
            // 获取终点的实际下标
            if (element === order.length - 1) {
              endIndex = index + 1
            }
          }
          if (this.shiftReservation.shiftFlag === 1) {
            endIndex = endIndex - 1
          }
          if (tIndex != null && this.shiftReservation.shiftFlag === 0) {
            endIndex = tIndex
          } else if (tIndex != null && this.shiftReservation.shiftFlag === 1) {
            endIndex = tIndex - 1
          }
          let useTime = 0
          // 计算两点之间的时间  /秒
          let index
          let end
          if (startIndex > endIndex) {
            index = endIndex
            end = startIndex
          } else {
            index = startIndex
            end = endIndex
          }
          if (this.shiftReservation.startStationId !== this.shiftReservation.arriveStationId) {
            // 根据两点实际下标获取时间
            legs.forEach(element => {
              if (index <= end) {
                useTime += legs[index].duration.inSeconds
                index++
              }
            })
          }
          // useTime += this.shiftReservation.pickUpWaitTime
          // Object.is(element.arrivePointPassengers, undefined)
          // for (let i = 0; i < this.shiftDetail.shiftPasspoints.length - 1; i++) {
          //   const shiftP = this.shiftDetail.shiftPasspoints[i]
          //   if ((!Object.is(shiftP.arrivePointPassengers, undefined) && shiftP.arrivePointPassengers.length > 0 && shiftP.routeType === '0') || (!Object.is(shiftP.arrivePointPassengers, undefined) && shiftP.startPointPassengers.length > 0 && shiftP.routeType === '0')) {
          //     if (i <= start + 1) {
          //       this.shiftReservation.pickUpWaitTime = 0
          //       break
          //     }
          //   }
          // }
          this.shiftReservation.pickUpWaitTime = 0
          // 获取乘车预定时间
          if (this.shiftReservation.shiftFlag === 0) {
            let time = DateUtil.planMin(this.tation.estimateTime, useTime, this.shiftReservation.shiftFlag, this.shiftReservation.pickUpWaitTime)
            this.shiftReservation.time.arriveEstimateTime = DateUtil.hourMinute(time[2])
            this.shiftReservation.arriveEstimateTime = time[2]
            this.shiftReservation.startEstimateTime = time[0]
            this.shiftReservation.time.startEstimateTime = time[1]
          } else {
            let time = DateUtil.planMin(this.tation.estimateTime, useTime, this.shiftReservation.shiftFlag, this.shiftReservation.pickUpWaitTime)
            this.shiftReservation.time.startEstimateTime = DateUtil.hourMinute(time[2])
            this.shiftReservation.startEstimateTime = time[2]
            this.shiftReservation.arriveEstimateTime = time[0]
            this.shiftReservation.time.arriveEstimateTime = time[1]
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 便一覧作成
    getShiftList () {
      console.log("getShiftList")
      this.shiftPasspoints = []

      // 便一覧からparentShiftIdが同じ便情報をすべて取得
      let currentMonth = this.shiftReservation.useTime.substr(0,6)
      let parentShiftId
      if(this.shiftReservation.transportKind == 0){
        parentShiftId = this.shiftReservation.shiftId
        this.shiftReservation.parentShiftId = parentShiftId
      }else if(this.shiftReservation.transportKind == 1){
        parentShiftId = this.shiftReservation.parentShiftId
      }
      this.shiftReservation.shiftId = parentShiftId
      
      this.$axios.get('shift/queryShiftInfoListForReservation', {params: {parentShiftId: parentShiftId}}).then(response => {
        let shiftInfoList
        console.log('接続便一覧')
        shiftInfoList = response.data.shiftInfoList
        for (let shiftInfoTemp of shiftInfoList) {
          let shiftModelTemp = {
            shiftId: '',
            shiftFlag: '',
            title: '',
            arriveEstimateTimeSlot: '',
            startEstimateTimeSlot: '',
            shiftPasspoints: {}
          }
          // 親（区域内）便の処理
          if(shiftInfoTemp.shiftId == parentShiftId) {
            // 行き帰りフラグを取得
            this.shiftReservation.shiftFlag = shiftInfoTemp.shiftFlag
            this.shiftReservation.title = shiftInfoTemp.title
            this.shiftReservation.driverUid = shiftInfoTemp.driveUid
            shiftModelTemp.shiftFlag = shiftInfoTemp.shiftFlag
          }
          // すべての接続便の処理
          if(shiftInfoTemp.shiftId == parentShiftId || shiftInfoTemp.parentShiftId == parentShiftId){
            shiftModelTemp.shiftId = shiftInfoTemp.shiftId
            shiftModelTemp.title = shiftInfoTemp.title

            if (shiftInfoTemp.shiftFlag === 0) {
              shiftModelTemp.startEstimateTimeSlot = shiftInfoTemp.startEstimateTimeSlot
            } else {
              shiftModelTemp.arriveEstimateTimeSlot = shiftInfoTemp.arriveEstimateTimeSlot
            }
            shiftModelTemp.shiftPasspoints = shiftInfoTemp.shiftPasspoints

            for(let i = 0; i < shiftModelTemp.shiftPasspoints.length; i++){
              shiftModelTemp.shiftPasspoints[i].shiftId = shiftModelTemp.shiftId
              if(shiftModelTemp.shiftPasspoints[i].arriveEstimateTime != ''&&shiftModelTemp.shiftPasspoints[i].arriveEstimateTime != null){
                shiftModelTemp.shiftPasspoints[i].estimateTime = shiftModelTemp.shiftPasspoints[i].arriveEstimateTime
              }else{
                shiftModelTemp.shiftPasspoints[i].estimateTime = shiftModelTemp.shiftPasspoints[i].startEstimateTime
              }
              this.shiftPasspoints.push(shiftModelTemp.shiftPasspoints[i])
            }
            // this.shiftPasspoints.push(shiftModelTemp.shiftPasspoints)
            this.connectShiftList.push(shiftModelTemp)
          }
        }

        if(this.shiftReservation.flag ==='edit'){
          for(let i = 0; i < this.shiftPasspoints.length; i++){
            if(this.shiftReservation.shiftFlag === 0){
              if(this.shiftPasspoints[i].stationId == this.shiftReservation.arriveStationId){
                // this.shiftReservation.arriveShiftId = this.shiftPasspoints[i].shiftId
                this.shiftReservation.arriveShiftId = this.shiftReservation.groupArriveShiftId
              }
            }else if(this.shiftReservation.shiftFlag === 1){
              if(this.shiftPasspoints[i].stationId == this.shiftReservation.startStationId){
                // this.shiftReservation.startShiftId = this.shiftPasspoints[i].shiftId
                this.shiftReservation.startShiftId = this.shiftReservation.groupStartShiftId
              }
            }
          }
        }

        // 设置地图的中心点在路线中心
        this.centerPoint = {
          lat: (this.shiftPasspoints[0].stationLat + this.shiftPasspoints[this.shiftPasspoints.length - 1].stationLat) / 2,
          lng: (this.shiftPasspoints[0].stationLng + this.shiftPasspoints[this.shiftPasspoints.length - 1].stationLng) / 2
        }
        this.isLoading = false
      })
    },
    // 乗車便選択時処理
    chooseStartShift () {
      this.tation = null
      // 便名を取得してセット
      for (let i = 0; i < this.connectShiftList.length; i++) {
        if (this.connectShiftList[i].shiftId === this.shiftReservation.startShiftId) {
          this.shiftReservation.startShiftTitle = this.connectShiftList[i].title
        }
      }
    },
    // 降車便選択時処理
    chooseArriveShift () {
      this.tation = null
      // 便名を取得してセット
      for (let i = 0; i < this.connectShiftList.length; i++) {
        if (this.connectShiftList[i].shiftId === this.shiftReservation.arriveShiftId) {
          this.shiftReservation.arriveShiftTitle = this.connectShiftList[i].title
        }
      }
    },
    checkEstimateTime () {
      console.log("this.checkEstimateTime")
      if(this.shiftReservation.arriveEstimateTime <= this.shiftReservation.startEstimateTime){
        this.dialogOption.showNo = false
        this.dialogOption.text = '乗車場所と降車場所の順序が正しくありません。'
        this.dialogOption.confirmButtonText = '確定'
        this.showDialog = true
        this.$refs.dialog.confirm().then(() => {
          this.showDialog = false
          this.tation = null
          if (this.shiftReservation.shiftFlag === 0) {
            this.shiftReservation.arriveStationId = ''
          } else {
            this.shiftReservation.startStationId = ''
          }
        })
      }
    },
    updateReservationPassengerCost(){
      if(this.delegateCost === null){
        this.shiftReservation.passengerCost = this.shiftReservation.passengerNumber * this.shiftCost
      }else{
        this.shiftReservation.passengerCost = this.shiftReservation.passengerNumber * this.delegateCost 
      }
    },
    // 予約締切時刻を過ぎていたら、停留所時刻をすべて再取得
    // 定時バッチによって停留所時刻が抜け落ちている可能性があるため
    getEstimateTimeAfterOptimize(){
      this.$axios.get('shift/getReservationModificationTime').then(response => {
        let reservationModificationTime = response.data.reservationModificationTime.substr(0,4)
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        let day = date.getDate() >= 10 ? date.getDate() : '0' + (date.getDate())
        let hour = date.getHours() >= 10 ? date.getHours() : '0' + (date.getHours())
        let minute = date.getMinutes()
        if (minute < 10) {
          minute = '0' + minute
        }
        let currentDate = year.toString() + month.toString() + day.toString()
        let currentTime = hour.toString() + minute.toString()
        let dateDiff = Number(currentDate) - Number(this.shiftReservation.useTime)

        console.log("締切時刻は" + reservationModificationTime)
        console.log("現在時刻は" + currentTime)
        console.log("予約日は" + this.shiftReservation.useTime)
        console.log("今日は" + currentDate)
        console.log("日付の差は" + dateDiff)

        // 予約日の前日かつ締め切り時刻を過ぎている
        // または予約当日以降なら 定時バッチ処理が入っていると判断し、停留所時刻再取得を実施
        if( (dateDiff === -1 && Number(reservationModificationTime) <= Number(currentTime))
        ||  (0 <= dateDiff) ){
          console.log("時刻を過ぎています")
          this.$axios.get('shift/getEstimatePasspointList', {params: {shiftId: this.shiftReservation.shiftId}}).then(response => {
            let estimatePasspointList = response.data.estimatePasspointList
            for(let frontIndex = 0; frontIndex < this.shiftPasspoints.length; frontIndex++){
              for(let estimateIndex = 0; estimateIndex < estimatePasspointList.length; estimateIndex++){
                if(this.shiftPasspoints[frontIndex].stationId == estimatePasspointList[estimateIndex].stationId){
                  this.shiftPasspoints[frontIndex].estimateTime = estimatePasspointList[estimateIndex].arriveEstimateTime
                }
              }
            }
          })
        }
      })
    }
  },
  data () {
    return {
      mapId2: 'stayplace',
      event: '',
      tation: '',
      options: [],
      name: '',
      withNumber: 0,
      isShow: false,
      flag: true,
      startStationIndex: 0,
      arriveStationIndex: 0,
      startType: 0,
      startEstimateTime: '',
      oldLat: 0,
      oldLng: 0,
      shiftReservation: {
        arrivePlaceType: '',
        firstName: '',
        pickUpWaitTime: 0,
        arriveEstimateTime: '',
        arriveStationId: '',
        firstNameKana: '',
        lastName: '',
        lastNameKana: '',
        moveShiftTime: '',
        useTime: '',
        shiftTime: '',
        name: '',
        passengerCost: '',
        passengerNumber: 1,
        passengerUid: '',
        driverUid: '',
        reserveTime: '',
        reserveType: '',
        shiftId: '',
        title: '',
        startPlaceType: '',
        reserveId: '',
        status: '',
        shiftFlag: '',
        startPlaceName: '',
        arrivePlaceName: '',
        size: 0,
        time: {
          reserveTime: '',
          useTime: '',
          startEstimateTime: '',
          arriveEstimateTime: ''
        },
        note: null,
        startStationId: '',
        parentShiftId: '',
        startShiftId: '',
        startShiftTitle: '',
        arriveShiftId: '',
        arriveShiftTitle: '',
      }, // 预约情报
      shiftDetail: {},
      userInfo: [], // 乘客情报
      shiftPasspoints: {},
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      homeLat: '',
      homeLng: '',
      centerPoint: null,
      numberFlag: null,
      // 地域外交通対応
      // 便エリアID
      areaId: null,
      // 便一覧
      shiftList: {},
      // 区分
      transportKind: 0,
      // 接続便一覧
      connectShiftList: [],
      connectShiftPasspoints: {},
      // ロード中フラグ
      isLoading: true,
      // 便選択無効フラグ
      disableStartShift: false,
      disableArriveShift: false,
      // 便金額
      shiftCost: 0,
      // 代表者金額
      delegateCost: null
    }
  }
}
</script>

<template>
<right-layout>
  <div class="col-md-12 column" id="passengerFlag" style="width:100%;display:flex;flex-direction: column;flex:1">
    <div class="row clearfix" style="flex: 0 0 40px">
      <div class="col-md-12 column">
        <div class="row clearfix">
          <div class="col-md-12 column T7-title F2-M-27">
             乗客予約
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-3 column clearfix" style="min-width: 320px;margin-left: 2%">
            <span class="F3-R-14">※必須項目</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix slider" style="flex: 1 1 0">
      <div class="col-md-1 column">
      </div>
      <div class="col-md-10 column" style="margin-left: 10%">
        <div class="row clearfix">
          <div class="col-md-12 column">
            <div class="row clearfix">
                <div class="col-md-2 column divTitle shortDiv">
                    <div class="row clearfix F3-R-15 bgc8">
                        <div class="col-md-3 column clearfix">
                        </div>
                        <div class="col-md-8 column clearfix textAlignLeft">
                            便名
                        </div>
                    </div>
                </div>
                <div class="col-md-2 column shortInput" style="width: 83%;min-width: 110px;">
                    <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.title}}</div>
                </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    便ID
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" >
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.shiftId}}</div>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-show="shiftReservation.flag ==='add'">
                <div class="row clearfix F3-R-15 bgc8">
                 <div class="col-md-3 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    ステータス
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" v-show="shiftReservation.flag ==='add'">
                <div class="divTitle longsolid bgc5 F3-R-20" v-text="shiftReservation.status==1?'確定':'キャンセル待ち'"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop" v-show="shiftReservation.flag ==='edit'">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                      予約ID
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.reserveId}}</div>
              </div>
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                 <div class="col-md-3 column clearfix" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0;">
                    ステータス
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20" v-text="shiftReservation.status==1?'確定':'キャンセル待ち'"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                     フリガナ
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20 overflow-fix">{{ name }}</div>
              </div>
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                 <div class="col-md-3 column clearfix" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0;">
                    予約受付方法
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                 <div v-show="shiftReservation.flag ==='edit'"  class="divTitle longsolid bgc5 F3-R-20" v-text="shiftReservation.reserveType==1?'電話':'アプリ'"></div>
                 <select v-show="shiftReservation.flag ==='add'" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;" v-model="shiftReservation.reserveType" @change="reserveType(shiftReservation.reserveType)" data-live-search="true">
                      <option value="1">電話</option>
                      <option :selected="shiftReservation.reserveType==2?'selected':null" value="2">アプリ</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix" style="padding:0" v-text="shiftReservation.flag ==='add'?'※':''">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                     乗客(代表者)
                  </div>
                </div>
              </div>
             <div class="col-md-2 column shortInput">
                <div v-if="shiftReservation.flag ==='edit'"  class="divTitle longsolid bgc5 F3-R-20">{{this.shiftReservation.lastName + this.shiftReservation.firstName}}</div>
                <select v-if="shiftReservation.flag ==='add'" :title="this.shiftReservation.flag=='edit'?'':'    '" name="slpk" v-validate="'required'" id="slpk"
                class="form-control F3-R-20 selectImg" style="width:100%;height:46px;padding-right:30px;" data-width="100%" data-height="46px"  data-live-search="false"
                v-model="event" @change="selectPassengerEvent(event)">
                    <option v-for="(user, index) in userInfo" :key="index" :value="user" v-show="user.uid != shiftReservation.driverUid">{{ user.lastName}} &nbsp;{{user.firstName }}</option>
                </select>
              </div>
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                 <div class="col-md-3 column clearfix" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    予約受付日時
                  </div>
                </div>
              </div>
             <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.time.reserveTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix" v-if="shiftReservation.flag ==='add'">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('slpk')" class="errorMessage"> {{ errors.first('slpk') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0px">
                     利用日
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.time.useTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 乗車便 -->
        <div class="row clearfix divMarginTop" v-if="shiftReservation.shiftFlag==1">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix" style="padding:0">
                      ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    乗車便
                  </div>
                </div>
              </div>
              <div class="col-md-8 column" style="width:82.7%">
                <select name="arrPlace" v-validate="'required'" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;" v-model="shiftReservation.startShiftId" @change="chooseStartShift()" :disabled="disableStartShift">
                    <option :value="item.shiftId" :key="index" v-for="(item, index) of connectShiftList">{{item.title}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- 乗車場所 -->
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix" style="padding:0">
                      ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                     乗車場所
                  </div>
                </div>
              </div>
              <div v-if="shiftReservation.shiftFlag==1" class="col-md-8 column" style="width:82.7%">
                <select name= "startPlace" v-validate="'required'"  class="form-control F3-R-20 selectImg"   style="width:100%;height:46px;"  data-live-search="true" v-model="tation" @change="station(tation)">
                  <option :value="item" 
                          v-show="item.routeType==0
                                &&item.shiftId==shiftReservation.startShiftId
                                &&item.officeFlag===0
                                &&index !== shiftPasspoints.length-1" 
                          :key="index" v-for="(item, index) of shiftPasspoints">{{item.stationName}}</option>
                </select>
              </div>
              <div v-if="shiftReservation.shiftFlag==0" class="col-md-8 column" style="width:68.5%">
                <select id="startPlaceSelect" name= "startPlace" v-validate="'required'" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;" v-model="shiftReservation.startPlaceType" @change="startPlaceType(shiftReservation.startPlaceType)" data-live-search="true">
                  <option  value="1">自宅</option>
                </select>
              </div>
              <div v-if="shiftReservation.shiftFlag==0" class="col-md-2 column shortDiv paddingLeftZero paddingRightZero">
                <a href="#modal-container-addressChoice" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                  <button  style="width:100%" class="T7-radius detailed-button F2-R-19"  @click="initAddressChoice" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" :disabled="this.shiftReservation.passengerUid===''||this.shiftReservation.passengerUid===null">
                      マップで探す
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
         <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('startPlace')" class="errorMessage"> {{ errors.first('startPlace') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-2 column clearfix" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                     乗車予定時間
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.time.startEstimateTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 降車便 -->
        <div class="row clearfix divMarginTop" v-if="shiftReservation.shiftFlag==0">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix" style="padding:0">
                      ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    降車便
                  </div>
                </div>
              </div>
              <div class="col-md-8 column" style="width:82.7%">
                <select name="arrPlace" v-validate="'required'" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;" v-model="shiftReservation.arriveShiftId" @change="chooseArriveShift()" :disabled="disableArriveShift">
                    <option :value="item.shiftId" :key="index" v-for="(item, index) of connectShiftList">{{item.title}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- 降車場所 -->
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix" style="padding:0">
                      ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    降車場所
                  </div>
                </div>
              </div>
              <div v-if="shiftReservation.shiftFlag==1" class="col-md-8 column" style="width:68.5%">
                  <select id="startPlaceSelect" v-validate="'required'" name="arrPlace" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;" data-live-search="true" v-model="shiftReservation.arrivePlaceType" @change="startPlaceType(shiftReservation.arrivePlaceType)">
                      <option value="1">自宅</option>
                  </select>
                </div>
                <div v-if="shiftReservation.shiftFlag==1" class="col-md-2 column shortDiv paddingLeftZero paddingRightZero">
                  <a href="#modal-container-addressChoice" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                    <button  style="width:100%" class="T7-radius detailed-button F2-R-19"  @click="initAddressChoice" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" :disabled="this.shiftReservation.passengerUid===''||this.shiftReservation.passengerUid===null">
                        マップで探す
                    </button>
                  </a>
                </div>
                <div v-if="shiftReservation.shiftFlag==0" class="col-md-8 column" style="width:82.7%">
                  <select name="arrPlace" v-validate="'required'" class="form-control F3-R-20 selectImg" style="width:100%;height:46px;"  data-live-search="true" v-model="tation" @change="station(tation)">
                      <option  :value="item" 
                                v-show="item.routeType==0
                                      &&item.shiftId==shiftReservation.arriveShiftId
                                      &&item.officeFlag===0
                                      &&index !== 0" 
                                :key="index" v-for="(item, index) of shiftPasspoints">{{item.stationName}}</option>
                  </select>
                </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
        <div class="col-md-2 column shortDiv">
        </div>
        <div class="col-md-10 column textAlignLeft">
          <span v-show="errors.has('arrPlace')" class="errorMessage"> {{ errors.first('arrPlace') }} </span>
        </div>
      </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-2 column clearfix" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding:0">
                    降車予定時間
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput">
                <div class="divTitle longsolid bgc5 F3-R-20">{{shiftReservation.time.arriveEstimateTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix F3-R-15 ">
              <div class="col-md-2 column divTitle shortDiv bgc8" style="height: 150px; line-height: 150px;">
                備考
              </div>
              <div class="col-md-10 column">
                <textarea v-model="shiftReservation.note" maxlength="256" class="textareastyle F3-R-20" name="passengerNote" v-validate="'paintWordNo'"></textarea>
              </div>
            </div>
          </div>
        </div>
         <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('passengerNote')" class="errorMessage"> {{ errors.first('passengerNote') }} </span>
          </div>
        </div>
        <div class="row clearfix" style="margin-top:6px">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column shortDiv divTitle">
                <div class="row clearfix F3-R-15 bgc14">
                  <div class="col-md-3 column clearfix textAlignLeft" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                   同乗者
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput">
                  <input
                  id="withNumber"
                  name="number"
                  type="text"
                  v-validate="'numeric'"
                  v-model="withNumber"
                  class="col-md-4 F3-R-20" style="border:1px solid black;width:20%;height: 46px;background-color: #ffffff"/>
                 <p class="col-md-1" style="height:46px;font-size:18px;padding-top:20px;padding-left:0px;">人</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('number')" class="errorMessage"> {{ errors.first('number') }} </span>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column shortDiv divTitle">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-3 column clearfix textAlignLeft" style="padding:0">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                   利用料金
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput">
                  <input
                  type="text"
                  maxlength="9"
                  disabled="disabled"
                  v-model="shiftReservation.passengerCost"
                  class=" col-md-2 bgc5 inputstyles F3-R-20" style="width:50%"/>
                <p class="col-md-1 F3-R-20" style="height:46px;padding-top:20px;padding-left:0px;">円</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix" style="margin-bottom:30px;">
      <div class="col-md-1 column">
      </div>
      <div class="col-md-10 column" style="margin-left: 10%">
        <div class="row clearfix">
          <div class="col-md-6 column">
            <!-- <a id="modal-475051"  href="#modal-container-475051" @click="submit()" data-toggle="modal"> -->
              <button class="T7-larginbtn window-button" style="width:76%" @click="canCancelWaitReserve()">登録</button>
            <!-- </a> -->
          </div>
          <div class="col-md-6 column">
            <button class=" T7-larginbtn window-button" style="margin-left: -30%;width:76%"  @click="goback">キャンセル</button>
          </div>
        </div>
      </div>
      <div class="col-md-1 column">
      </div>
    </div>
  </div>
<seachAddress @getAddress="getHomeAddress"  ref="homeAddressChoice"></seachAddress>
<v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
<passengerReservationconfirm  ref="confirm" href="#modal-container-475051"  :time="shiftReservation.time"  :shiftReservation="shiftReservation"></passengerReservationconfirm>
</right-layout>
</template>

<style scoped>
.T7-title {
  margin-top: 25px;
  font-size: 25px;
  color: black;
}
.divTitle {
  height: 46px;
  line-height: 46px;
}
.T7-radius {
  width: 80%;
  max-width: 200px;
  height: 46px;
  background: rgb(109, 109, 109);
  border-radius: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 17px;
  padding: 0;
  border: solid 1px;
}
.T7-longtitle {
  width: 100%;
  background: #cecece;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  text-align: left;
  font-weight: 550;
  color: black;
}
.inputstyles {
  height: 46px;
  text-align: left;
  padding-left: 10px;
  border:0px solid #ccc;
}
.radiodiv {
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
.checkBoxDiv {
  font-size: 18px;
  margin-top: 5px;
  text-align: left;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
input[type="checkbox"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
.rightwidth {
  width: 450px;
}
.leftwidth {
  width: 450px;
}
.textareastyle {
  width: 100%;
  height: 150px;
  font-size: 16px;
  border: solid 1px #ccc;
  padding: 6px 12px;
}
.longsolid {
  font-size: 16px;
  padding: 0px 12px;
  text-align: left;
}
.fileInput {
  position: absolute;
  clip: rect(0 0 0 0);
}
.imageStyle {
  width: 100%;
  height: 200px;
}
.idImageStyle {
  width: 100%;
  height: 350px;
}
.textAlignLeft {
  text-align: left;
}
.textAlignRight {
  text-align: right;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.shortInput {
  width: 35%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.bottomDiv {
  margin-top: 20px;
  background: rgb(234, 234, 234);
  width: 97.45%;
  min-width: 816px;
}
.itemDiv {
  width: 28%;
  min-width: 130px;
}
.itemInput {
  width: 107%;
}
.itemMargin {
  margin-left: 0.01%;
}
.divMarginTop {
  margin-top: 10px;
}
.errorMessage {
  color: red;
}
.wordBre {
  word-break: break-all;
}
.noimg-style{
    display: flex;
    justify-content: center;
    align-items: center;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
 -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../../assets/dropselect.png") no-repeat scroll right center transparent;
}
.selectImg:disabled {
  opacity: 0.6;
  /* color: gray!important; */
}
</style>



// WEBPACK FOOTER //
// src/router/views/passengerReservation.vue